<template>
  <main id="main" class="--full">
    <section class="clothing__wardrobe">
      <ReturnButton top wardrobe />
      <AvatarFull />
      <ClothingBar />
    </section>
  </main>
</template>

<script>
import { AvatarFull } from '@/components/avatar'
import { ClothingBar } from '@/components/clothing'
import { ReturnButton } from '@/components/small'
import { PageMetaMixin } from '@/mixins'

export default {
  name: 'Avatar',
  mixins: [PageMetaMixin],
  beetPage: 'hunt_wardrobe',
  components: { AvatarFull, ClothingBar, ReturnButton },
}
</script>
